export default "__VITE_ASSET__BW3nvKrS__"